import { Box, Pagination, PaginationProps, Paper } from '@mui/material';
import React from 'react';

export default function PaginationBar(props: PaginationProps) {
  return (
    <Box component={Paper}>
      <Pagination {...props} />
    </Box>
  );
}
